module.exports = __webpack_public_path__ + "img/bg-handover-sti-now.6c970871.svg";